'use strict';

import type { AgencyLeadStatus } from '../../Entities/Agency/AgencyLeadStatus';
import { EntityCollection } from '../EntityCollection';

export class AgencyLeadStatusCollection extends EntityCollection<AgencyLeadStatus> {}
